import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import TestChat from './pages/TestChat'
import Compare from './pages/Compare'
import Files from './pages/Files'
import Memory from './pages/Memory'
import Projects from './pages/Projects'
import RoutingPreferences from './pages/Settings/RoutingPreferences'
import ModelCatalog from './pages/Models/ModelCatalog'
import NovitaDeployments from './pages/Models/NovitaDeployments'
import Usage from './pages/Analytics/Usage'
import Costs from './pages/Analytics/Costs'
import PromoCodes from './pages/Promo/PromoCodes'
import CreatorCodes from './pages/Creators/CreatorCodes'
import GeminiAccounts from './pages/Gemini/GeminiAccounts'
import ChatGPTAccounts from './pages/ChatGPT/ChatGPTAccounts'
import ClaudeAccounts from './pages/Claude/ClaudeAccounts'
import AuditLogs from './pages/Logs/AuditLogs'
import UserList from './pages/Users/UserList'
import UserDetail from './pages/Users/UserDetail'
import EmailTemplates from './pages/Mailing/EmailTemplates'
import Newsletter from './pages/Mailing/Newsletter'
import EmailLogs from './pages/Mailing/EmailLogs'
import PollList from './pages/Polls/PollList'
import PollForm from './pages/Polls/PollForm'
import PollResults from './pages/Polls/PollResults'
import HFModelList from './pages/HFModels/HFModelList'
import HFModelStats from './pages/HFModels/HFModelStats'
import Layout from './components/Layout'

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/files" element={<Files />} />
                <Route path="/memory" element={<Memory />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/settings/routing" element={<RoutingPreferences />} />
                <Route path="/models" element={<ModelCatalog />} />
                <Route path="/novita" element={<NovitaDeployments />} />
                <Route path="/usage" element={<Usage />} />
                <Route path="/costs" element={<Costs />} />
                <Route path="/promo-codes" element={<PromoCodes />} />
                <Route path="/creators" element={<CreatorCodes />} />
                <Route path="/gemini-accounts" element={<GeminiAccounts />} />
                <Route path="/chatgpt-accounts" element={<ChatGPTAccounts />} />
                <Route path="/claude-accounts" element={<ClaudeAccounts />} />
                <Route path="/logs" element={<AuditLogs />} />
                <Route path="/users" element={<UserList />} />
                <Route path="/users/:id" element={<UserDetail />} />
                <Route path="/mailing/templates" element={<EmailTemplates />} />
                <Route path="/mailing/newsletter" element={<Newsletter />} />
                <Route path="/mailing/logs" element={<EmailLogs />} />
                <Route path="/polls" element={<PollList />} />
                <Route path="/polls/new" element={<PollForm />} />
                <Route path="/polls/:id/edit" element={<PollForm />} />
                <Route path="/polls/:id/results" element={<PollResults />} />
                <Route path="/hf-models" element={<HFModelList />} />
                <Route path="/hf-models/:id/stats" element={<HFModelStats />} />
                <Route path="/test-chat" element={<TestChat />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
